// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__bBh-S","container":"intro_container__yux0s","title":"intro_title__o3W3r","sub":"intro_sub__JKcNR","sub2":"intro_sub2__TEvAn","hr":"intro_hr__nx9sn"};